import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { publicAxios } from '../../apiEcommerce';

const initialState = {
  categoriesProducts: [],
  status: 'idle',
  error: null,
};

export const fetchCategoriesPro = createAsyncThunk('categoriesProducts/fetchCategoriesPro', async () => {
  const response = await publicAxios.get('/api/ecomerce/categories');
  return response.data.data.categories;
});

const categoriesProductsSlice = createSlice({
  name: 'categoriesProducts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesPro.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCategoriesPro.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.categoriesProducts = action.payload;
      })
      .addCase(fetchCategoriesPro.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default categoriesProductsSlice.reducer;